import React, { Component } from "react";

import {
  CCard,
  CCardHeader,
  CCardBody,
  CCol,
  CCollapse,
  CButton,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CLink,
  CPagination
} from "@coreui/react";
import { connect } from "react-redux";
import Select from "react-select";
import {
  InputGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  Label
} from "reactstrap";
import { bindActionCreators } from "redux";

import ContentItem from "./ContentItem";
import { logout } from "../../actions/baseActions";
import DefaultDiscipline from "../../assets/imgs/disciplines/default.PNG";
import URL from "../../config/api";
import axios from "../../config/axios";
import Loading from "../Loading";

import "./css/content.css";

class ContentComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      selected: [],
      filters: {},
      modal: false,
      modalOrder: false,
      content: [],
      activity: false,
      // selection: [],
      contentList: {
        type: null,
        list: []
      },
      segments: [],
      // disciplines: [],
      // objectives: [],
      // modules: [],
      // units: [],
      // series: [],
      filter: {
        word: null,
        segment: { value: null, label: "Todos" },
        discipline: { value: null, label: "Todos" },
        serie: { value: null, label: "Todas" },
        module: { value: null, label: "Todos" },
        ability: { value: null, label: "Todos" }
      },
      filterCollapse: false,
      type: this.props.type,
      ability_filter: false,
      maxItems: 24,
      currentPage: 1,
      lastPage: 1,
      modulesSegments: null,
      abilitiesSegments: null,
      allowedDisciplineIds: []
    };
  }

  componentWillUnmount() {
    axios
      .all([
        axios.get(
          `${URL.api}content/los/filterStructureObjective/${this.state.type}`,
          {
            headers: { authorization: `Bearer ${this.props.user.token}` },
            params: { bncc: "ability" }
          }
        ),
        axios.get(
          `${URL.api}content/los/filterStructureObjective/${this.state.type}`,
          {
            headers: { authorization: `Bearer ${this.props.user.token}` },
            params: { bncc: "module" }
          }
        )
      ])
      .then(
        // resp = filtros de Habilidades, respModules = filtros de Eixo Temático
        axios.spread((resp, respModules) => {
          let filter = {
            word: null,
            segment: { value: null, label: "Todos" },
            discipline: { value: null, label: "Todos" },
            serie: { value: null, label: "Todas" },
            module: { value: null, label: "Todos" },
            ability: { value: null, label: "Todos" }
          };

          if (this.props.serie) {
            const segment = resp.data.data.find(item =>
              item.series.find(serie => serie.id === parseInt(this.props.serie))
            );
            const serie = segment.series.find(
              serie => serie.id === parseInt(this.props.serie)
            );

            if (segment) {
              filter.segment = { value: segment.id, label: segment.name };
            }

            if (serie) {
              filter.serie = {
                value: serie.id,
                label: serie.name
              };
            }
          }

          if (this.props.discipline) {
            const segment = resp.data.data.find(item =>
              item.series.find(serie =>
                serie.disciplines.find(
                  discipline =>
                    discipline.id === parseInt(this.props.discipline)
                )
              )
            );
            const serie = segment.series.find(serie =>
              serie.disciplines.find(
                discipline => discipline.id === parseInt(this.props.discipline)
              )
            );
            const discipline = serie.disciplines.find(
              discipline => discipline.id === parseInt(this.props.discipline)
            );

            if (discipline) {
              filter.discipline = {
                value: discipline.id,
                label: discipline.name
              };
            }
          }

          // Mexer aqui para colocar 2 segments: 1 para habilidades e outro para Eixo Estratégico
          this.setState(
            {
              segments: resp.data.data,
              filter,
              filters: filter,
              modulesSegments: respModules.data.data,
              abilitiesSegments: resp.data.data
            },
            () => {
              this.setType();
            }
          );

          if (this.props.isOfflineRegister && this.props.disciplineSelected) {
            // eslint-disable-next-line react/no-access-state-in-setstate
            let newFilter = this.state.filter;
            newFilter.discipline = this.props.disciplineSelected;
            this.setState({ filter: newFilter });
          }
        })
      );
  }

  takeContentSelected = (elem, contentId) => {
    if (elem.current) {
      const elemString =
        elem.current.getElementsByClassName("contentTitle")[0].innerText;
      this.props.addContent(elemString, contentId);
      this.props.hideModal(true);
    }
  };

  toggleModal = () => {
    this.setState(prevState => ({ modal: !prevState.modal }));
  };

  toggleModalOrder = () => {
    this.setState(prevState => ({ modalOrder: !prevState.modalOrder }));
  };

  setType = () => {
    const filter = this.props.general.filtered_content;
    let { type } = this.state;

    if (filter) {
      type = filter.type;
    }

    if (type !== 0) {
      this.setState(
        {
          filters: {
            // eslint-disable-next-line react/no-access-state-in-setstate
            ...this.state.filters,
            // eslint-disable-next-line react/no-access-state-in-setstate
            type: this.state.type
          }
        },
        () => {
          this.getLos();
          if (this.props.activity) {
            this.setState({ activity: true });
          }
        }
      );
    } else {
      this.getLos();
    }
  };

  getLos = async () => {
    this.setState({ loading: true });

    const filters = {
      type: this.state.type,
      word: this.state.filters.word,
      segment: this.state.filters.segment && this.state.filters.segment.value,
      discipline:
        this.state.filters.discipline && this.state.filters.discipline.value,
      serie: this.state.filters.serie && this.state.filters.serie.value,
      module:
        !this.state.ability_filter &&
        this.state.filters.module &&
        this.state.filters.module.value,
      ability:
        this.state.ability_filter &&
        this.state.filters.ability &&
        this.state.filters.ability.value,
      content: true
    };

    const losResponse = await axios.post(
      // eslint-disable-next-line react/no-access-state-in-setstate
      `${URL.api}content/los/listLosFilter?page=${this.state.currentPage}&page_size=${this.state.maxItems}`,
      filters,
      {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      }
    );
    let respostaOrdenada = losResponse.data.data[0].content;
    respostaOrdenada.sort((a, b) => b.id - a.id);

    losResponse.data.data[0].content = respostaOrdenada;

    this.setState({
      content: losResponse.data.data,
      currentPage: losResponse.data.meta.current_page,
      lastPage: losResponse.data.meta.last_page,
      loading: false
    });
  };

  fitered = filters => {
    if (this.state.filters.type) {
      filters.type = this.state.filters.type;
    }

    this.setState({ filters }, () => {
      this.getLos();
    });
  };

  getSelected = select => {
    let { selected } = this.state;

    if (selected.length > 0) {
      selected.forEach((item, idx) => {
        if (item.id === select.id) {
          selected.splice(idx, 1);
        }
      });
    }

    selected.push(select);

    this.setState({ selected }, () => {
      let list = [];
      let { selected } = this.state;

      // ajusteMarvin ajustar pós inserir aula if (this.props.type === 1) {
      if (this.state.type === "0") {
        selected.forEach(lesson => {
          lesson.slides.forEach(slide => {
            if (slide.checked) {
              slide.father = lesson.id;
              list.push(slide);
            }
          });
        });
      } else {
        list = this.state.contentList.list;
        if (list.length > 0) {
          list.forEach((content, idx) => {
            if (content.id === select.id) {
              list.splice(idx, 1);
            } else {
              list.push(select);
            }
          });
        } else {
          list.push(select);
        }
      }

      this.setState({
        contentList: {
          // eslint-disable-next-line react/no-access-state-in-setstate
          type: this.state.content[0].id,
          list
        }
      });
    });
  };

  getOrder = (list, where) => {
    this.setState(
      {
        contentList: {
          // eslint-disable-next-line react/no-access-state-in-setstate
          type: this.state.content[0].id,
          list
        }
      },
      () => {
        this.finalize();
      }
    );
  };

  checked = item => {
    this.selectSlide(item);
    let { selectedLessons } = this.state;
    if (selectedLessons.length === 0) {
      selectedLessons.push(item);
    } else {
      selectedLessons.forEach((selected, idx) => {
        if (item.id === selected.id) {
          selectedLessons.splice(idx, 1);
        } else {
          selectedLessons.push(item);
        }
      });
    }
    this.setState(
      {
        selectedLessons
      },
      () => {
        this.finalize();
      }
    );
  };

  finalize = () => {
    // TODO fn para salvar as escolhas
    // this.props.getSelected(this.state.slideList)
  };

  send = () => {
    this.props.getContent(this.state.contentList);
  };

  filter(filters) {
    this.setState({ filters }, () => {
      this.getLos();
    });
  }

  changeFilter(prop, value) {
    this.setState(
      state => {
        let filter = { ...state.filter };
        filter[prop] = value;

        if (prop === "segment") {
          filter.serie = { value: null, label: "Todas" };
          filter.discipline = { value: null, label: "Todos" };
          filter.module = { value: null, label: "Todos" };
          filter.ability = { value: null, label: "Todos" };
        } else if (prop === "serie") {
          filter.discipline = { value: null, label: "Todos" };
          filter.module = { value: null, label: "Todos" };
          filter.ability = { value: null, label: "Todos" };
        } else if (prop === "discipline") {
          filter.module = { value: null, label: "Todos" };
          filter.ability = { value: null, label: "Todos" };
        }

        // Se o filtro estiver em Habilidades, carregar o abilitiesSegments, senão, carregar o modulesSegments
        let segments = state.ability_filter
          ? [...state.abilitiesSegments]
          : [...state.modulesSegments];

        return { segments, filter, filters: filter };
      },
      () => {
        if (prop !== "word") {
          this.filter(this.state.filter);
        }
      }
    );
  }

  render() {
    let img;
    if (this.state.filters.disciplines) {
      let discipline = this.state.filters.disciplines[0];
      img = DefaultDiscipline;
      if (discipline.symbol != null) {
        img = discipline.symbol;
      }
    }

    const filter = {
      word: this.state.filters.word,
      segment:
        this.state.filters.segment &&
        this.state.filters.segment.value &&
        this.state.filters.segment.label,
      discipline:
        this.state.filters.discipline &&
        this.state.filters.discipline.value &&
        this.state.filters.discipline.label,
      serie:
        this.state.filters.serie &&
        this.state.filters.serie.value &&
        this.state.filters.serie.label,
      module:
        this.state.filters.module &&
        this.state.filters.module.value &&
        this.state.filters.module.label,
      ability:
        this.state.filters.ability &&
        this.state.filters.ability.value &&
        this.state.filters.ability.label
    };

    let segments = this.state.segments
      .sort((a, b) => a.order - b.order)
      .map(segment => ({
        value: segment.id,
        label: segment.name,
        series: segment.series
      }));
    let series = [];
    let disciplines = [];
    let modules = [];
    let abilities = [];

    if (this.state.filter.segment?.value) {
      series = segments
        .filter(segment => segment.value === this.state.filter.segment.value)
        .reduce((acc, val) => [...acc, ...val.series], [])
        .sort((a, b) => a.order - b.order)
        .map(serie => ({
          value: serie.id,
          label: serie.name,
          disciplines: serie.disciplines
        }));
    } else {
      series = segments
        .reduce(
          (acc, val) => [
            ...acc,
            ...val.series.map(item => ({ ...item, segment_id: val.value }))
          ],
          []
        )
        .sort(
          (a, b) =>
            a.segment_id * 100 + a.order - (b.segment_id * 100 + b.order)
        )
        .map(serie => ({
          value: serie.id,
          label: serie.name,
          disciplines: serie.disciplines
        }));
    }

    if (this.state.filter.serie?.value) {
      disciplines = series
        .filter(serie => serie.value === this.state.filter.serie.value)
        .reduce((acc, val) => [...acc, ...val.disciplines], [])
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(discipline => ({
          value: discipline.id,
          label: discipline.name,
          modules: discipline.objectives,
          abilities: discipline.objectives
        }));
    } else {
      disciplines = series
        .reduce((acc, val) => [...acc, ...val.disciplines], [])
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(discipline => ({
          value: discipline.id,
          label: discipline.name,
          modules: discipline.objectives,
          abilities: discipline.objectives
        }));
    }

    if (this.state.filter.discipline?.value) {
      modules = disciplines
        .filter(
          discipline => discipline.value === this.state.filter.discipline.value
        )
        .reduce((acc, val) => [...acc, ...val.modules], [])
        .map(objective => ({
          label: objective.description,
          id: objective.id,
          options: objective.modules
            .filter(module => module.id)
            .sort((a, b) => a.name.localeCompare(b.name))
            .map(module => ({ value: module.id, label: module.name }))
        }));

      abilities = disciplines
        .filter(
          discipline => discipline.value === this.state.filter.discipline.value
        )
        .reduce((acc, val) => [...acc, ...val.abilities], [])
        .map(objective => ({
          label: objective.description,
          id: objective.id,
          options: objective.abilities
            .filter(ability => ability.id)
            .sort((a, b) => a.name.localeCompare(b.name))
            .map(ability => ({ value: ability.id, label: ability.name }))
        }));
    } else {
      modules = disciplines
        .reduce((acc, val) => [...acc, ...val.modules], [])
        .map(objective => ({
          label: objective.description,
          id: objective.id,
          options: objective.modules
            .filter(module => module.id)
            .sort((a, b) => a.name.localeCompare(b.name))
            .map(module => ({ value: module.id, label: module.name }))
        }));

      abilities = disciplines
        .reduce((acc, val) => [...acc, ...val.abilities], [])
        .map(objective => ({
          label: objective.description,
          id: objective.id,
          options: objective.abilities
            .filter(ability => ability.id)
            .sort((a, b) => a.name.localeCompare(b.name))
            .map(ability => ({ value: ability.id, label: ability.name }))
        }));
    }

    segments = [
      { value: null, label: "Todos" },
      ...segments.filter(
        (segment, index) =>
          segments.findIndex(item => item.value === segment.value) === index
      )
    ];
    series = [
      { value: null, label: "Todas" },
      ...series.filter(
        (serie, index) =>
          series.findIndex(item => item.value === serie.value) === index
      )
    ];
    disciplines = [
      { value: null, label: "Todos" },
      ...disciplines.filter(
        (discipline, index) =>
          disciplines.findIndex(item => item.value === discipline.value) ===
          index
      )
    ];
    modules = [
      { value: null, label: "Todos" },
      ...modules.filter(
        (module, index) =>
          modules.findIndex(item => item.id === module.id) === index &&
          module.options.length > 0
      )
    ];
    abilities = [
      { value: null, label: "Todos" },
      ...abilities.filter(
        (ability, index) =>
          abilities.findIndex(item => item.id === ability.id) === index &&
          ability.options.length > 0
      )
    ];

    const content = this.state.content.reduce(
      (acc, val) => [
        ...acc,
        ...val.content.map(item => ({ ...item, type_id: val.id }))
      ],
      []
    );
    const contentLength = content.length;

    return (
      <div className="animated">
        <CCard className="card-overflow">
          <CCardHeader className="d-flex align-items-center">
            <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
              <div className="d-flex align-items-center mb-1">
                <CDropdown>
                  <CDropdownToggle
                    className="d-flex align-items-center p-0"
                    style={{ boxShadow: "none" }}
                  >
                    <h4 className="card-title m-0 border-0 mr-1">
                      {this.props.types.find(
                        item => item.id === parseInt(this.state.type)
                      )?.name || "Conteúdo Multimídia"}
                    </h4>
                  </CDropdownToggle>
                  <CDropdownMenu>
                    <CDropdownItem
                      onClick={() =>
                        this.setState({ type: "0" }, () => this.getLos())
                      }
                      active={this.state.type === "0"}
                    >
                      Conteúdo Multimídia
                    </CDropdownItem>
                    {this.props.types
                      .filter(type => type.content === true)
                      .map(type => (
                        <CDropdownItem
                          key={type.id}
                          onClick={() =>
                            this.setState({ type: type.id.toString() }, () =>
                              this.getLos()
                            )
                          }
                          active={this.state.type === type.id.toString()}
                        >
                          {type.name}
                        </CDropdownItem>
                      ))}
                  </CDropdownMenu>
                </CDropdown>
              </div>
              <div className="small text-muted">
                Veja os conteúdos desse tipo
              </div>
            </div>
            <div
              className="float-right d-none d-lg-block"
              style={{ width: "30%" }}
            >
              <InputGroup>
                <Input
                  placeholder="Pesquisar"
                  onChange={e => this.changeFilter("word", e.target.value)}
                  value={this.state.filter.word}
                  type="text"
                  style={{
                    borderRight: 0,
                    outline: 0,
                    borderColor: "#d8dbe0",
                    boxShadow: "none"
                  }}
                />
                <InputGroupAddon addonType="append">
                  <InputGroupText className="bg-white pl-0">
                    <i
                      className="fa fa-search text-muted content-search-icon"
                      onClick={() => this.filter(this.state.filter)}
                    ></i>
                  </InputGroupText>
                </InputGroupAddon>
              </InputGroup>
            </div>
            <div className="float-right d-block d-lg-none">
              <CButton
                color="primary"
                onClick={() =>
                  this.setState(state => ({
                    filterCollapse: !state.filterCollapse
                  }))
                }
              >
                <i className="fa fa-filter"></i> Filtrar
              </CButton>
            </div>
          </CCardHeader>
          <CCardBody className="card-overflow">
            <CCollapse
              show={this.state.filterCollapse}
              className="d-lg-block card-overflow"
            >
              <div
                className="d-flex flex-column flex-md-row card card-overflow"
                style={{ padding: "1.25rem" }}
              >
                <div className="flex-1 d-block d-md-none">
                  <Label>Pesquisar</Label>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="fa fa-text-width"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Pesquisar"
                      onChange={e => this.changeFilter("word", e.target.value)}
                      value={this.state.filter.word}
                      type="text"
                      style={{
                        borderRight: 0,
                        outline: 0,
                        borderColor: "#d8dbe0",
                        boxShadow: "none",
                        flex: 1
                      }}
                    />
                    <InputGroupAddon addonType="append">
                      <InputGroupText className="bg-white pl-0">
                        <i
                          className="fa fa-search text-muted content-search-icon"
                          onClick={() => this.filter(this.state.filter)}
                        ></i>
                      </InputGroupText>
                    </InputGroupAddon>
                  </InputGroup>
                  <div className="p-2"></div>
                </div>
                <div className="flex-1">
                  <div className="w-100 text-ellipsis">
                    <Label className="d-block w-100 text-ellipsis">
                      Segmento
                    </Label>
                  </div>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="fa fa-text-width"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Select
                      placeholder="Segmento"
                      onChange={e => this.changeFilter("segment", e)}
                      value={this.state.filter.segment}
                      options={segments}
                      type="text"
                      className="flex-1"
                    />
                  </InputGroup>
                </div>
                <div className="p-2"></div>
                <div className="flex-1">
                  <div className="w-100 text-ellipsis">
                    <Label className="d-block w-100 text-ellipsis">Série</Label>
                  </div>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="fa fa-text-width"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Select
                      placeholder="Série"
                      onChange={e => this.changeFilter("serie", e)}
                      value={this.state.filter.serie}
                      options={series}
                      type="text"
                      className="flex-1"
                    />
                  </InputGroup>
                </div>
                <div className="p-2"></div>
                <div className="flex-1">
                  <div className="w-100 text-ellipsis">
                    <Label className="d-block w-100 text-ellipsis">
                      Componente curricular
                    </Label>
                  </div>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="fa fa-text-width"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Select
                      placeholder="Componente curricular"
                      onChange={e => this.changeFilter("discipline", e)}
                      value={this.state.filter.discipline}
                      options={disciplines}
                      type="text"
                      className="flex-1"
                    />
                  </InputGroup>
                </div>
                <div className="p-2"></div>
                <div className="flex-1">
                  <div className="w-100 text-ellipsis">
                    <Label className="d-block w-100 text-ellipsis">
                      {this.state.ability_filter
                        ? "Eixo temático BNCC"
                        : "Habilidades BNCC"}
                      <CLink
                        className="ml-2"
                        onClick={() =>
                          this.setState(
                            state => ({
                              ability_filter: !state.ability_filter
                            }),
                            () =>
                              this.changeFilter(
                                this.state.ability_filter
                                  ? "ability"
                                  : "module",
                                { value: null, label: "Todos" }
                              )
                          )
                        }
                      >
                        (
                        {this.state.ability_filter
                          ? "Habilidades BNCC"
                          : "Eixo temático BNCC"}
                        )
                      </CLink>
                    </Label>
                  </div>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="fa fa-text-width"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Select
                      placeholder={
                        this.state.ability_filter
                          ? "Habilidades BNCC"
                          : "Eixo temático BNCC"
                      }
                      key={this.state.ability_filter}
                      onChange={e =>
                        this.changeFilter(
                          this.state.ability_filter ? "ability" : "module",
                          e
                        )
                      }
                      value={
                        this.state.ability_filter
                          ? this.state.filter.ability
                          : this.state.filter.module
                      }
                      options={this.state.ability_filter ? abilities : modules}
                      type="text"
                      className="flex-1"
                    />
                  </InputGroup>
                </div>
              </div>
            </CCollapse>
            <div className="cardContent" style={{ minHeight: 0 }}>
              {this.state.loading ? (
                <Loading />
              ) : content.length > 0 ? (
                <div>
                  <div className="contentArea row">
                    {content.map((content, idc) => (
                      <CCol xs="12" md="6" lg="4" xl="3" key={`type-${idc}`}>
                        <ContentItem
                          type={this.state.type}
                          activity={this.state.activity}
                          key={`content-${content.type_id}-${content.id}`}
                          content={content}
                          icon={
                            this.props.types.find(
                              item => item.id === content.type_id
                            ).icon
                          }
                          color={
                            this.props.types.find(
                              item => item.id === content.type_id
                            ).color
                          }
                          getSelected={this.getSelected}
                          send={() =>
                            this.props.getContent(this.state.contentList)
                          }
                          currentRoute={this.props.currentRoute}
                          takeContentSelected={this.takeContentSelected}
                          isOfflineRegister={this.props.isOfflineRegister}
                        />
                      </CCol>
                    ))}
                  </div>
                  <hr className="my-4" />

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center"
                    }}
                  >
                    <div>
                      <span>Total de Conteúdos: {contentLength}</span>
                    </div>
                    <CPagination
                      className="m-0"
                      addListClass="m-0"
                      activePage={this.state.currentPage}
                      pages={this.state.lastPage}
                      onActivePageChange={page =>
                        this.setState({ currentPage: page }, () =>
                          this.getLos()
                        )
                      }
                    />
                  </div>
                </div>
              ) : (
                <div className="text-muted p-4 d-flex justify-content-center">
                  Nenhum conteúdo encontrado
                </div>
              )}
            </div>
          </CCardBody>
        </CCard>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ContentComponent);
